
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M11.0002 5V16.17L6.12021 11.29C5.73021 10.9 5.09021 10.9 4.70021 11.29C4.31021 11.68 4.31021 12.31 4.70021 12.7L11.2902 19.29C11.6802 19.68 12.3102 19.68 12.7002 19.29L19.2902 12.7C19.6802 12.31 19.6802 11.68 19.2902 11.29C18.9002 10.9 18.2702 10.9 17.8802 11.29L13.0002 16.17V5C13.0002 4.45 12.5502 4 12.0002 4C11.4502 4 11.0002 4.45 11.0002 5Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-arrow-downward`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconArrowDownward

    ```js
    <b-new-b-icon-arrow-downward />
    ```
</docs>


